// common.js
import cookies from "vue-cookies";

export function formatDate(date) {
    // Your date formatting logic here
}

export function capitalize(str) {
    // Your capitalize logic here
}

// 判断是否登录
export function isLogin() {
    var token = cookies.get("token");
    if (token && token != '') {
        return true;
    }
    return false;
}

// 跳往登录
export function toLogin() {
    // 获取当前页面的 URL
    const currentUrl = window.location.href;
    // 读取配置项 SSO_LOGIN_URL
    const ssoLoginUrl = process.env.SSO_LOGIN_URL;
    // 新的 URL 地址
    const loginUrl =
        ssoLoginUrl + "?redirect_url=" + encodeURIComponent(currentUrl);
    // 跳转到新的 URL 地址
    window.location.href = loginUrl;
}



// WEBPACK FOOTER //
// ./src/utils/common.js